import { render } from "./CountryChoice.vue?vue&type=template&id=57489bd7&scoped=true"
import script from "./CountryChoice.vue?vue&type=script&lang=js"
export * from "./CountryChoice.vue?vue&type=script&lang=js"

import "./CountryChoice.vue?vue&type=style&index=0&id=57489bd7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57489bd7"]])

export default __exports__